/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type FileManagementEditFileRequest = {
  id?: number | null;
  groupId?: number;
  title: string;
  openSatatus: FileManagementEditFileRequest.openSatatus;
  postDate?: string;
  postGroups: Array<string>;
  attachFiles: Array<string>;
  releaseSetting: string;
};

export namespace FileManagementEditFileRequest {
  export enum openSatatus {
    RELEASE = "release",
    DELETE = "delete",
    EDITING = "editing",
  }
}
